module.exports = __webpack_public_path__ + "img/home_banner_wrap2.e1076f19.png";